// No-op stub kept for backward compatibility — we use pure CSS animations now.
export function useReveal() {
  return { attach: undefined, className: "animate-fade-up" };
}
